<template> 
    <section v-if="selectedYn" > 
        <div class="division" v-if="view" @mouseover="overArea = true" @mouseleave="overArea = false" ><!-- v-if="view" -->
            <div class="sub_tit_box clear">
                <h3 class="fl ell-singleline" @click="moveCategoryMore" style="cursor: pointer; max-width: calc(95%); display: block;">{{category.categoryName}}</h3>
                <h3>({{boardListFilter.length}})</h3> 
            </div>
            <swiper :options="swiperOption" ref="mySwiper" class="list-card_square col-4">
                <!-- slides -->
                <swiper-slide class="clear" v-for="(board, index) in boardListFilter" :key="'paper_' + index">
                    <div class="list-top">
                        <div class="list-top clear">
                            <!-- <div class="list-team fl">미래전략실</div> -->
                            <div class="btn_top hover fr">
                                <button type="button" class="ico-switch_favorites"
                                        :class="board != null && board.paperBookmarkId != null ? 'active':''"  
                                        @click="toggleBookmark(board)" >즐겨찾기 
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="list-tit-s multi-ellipsis ellipsisdot" :class="category.categoryMid" @click="moveBoard(board)" 
                        @mouseenter="mouseEvt(true, board, $event)"
                        @mouseleave="mouseEvt(false, board, null)"
                        v-html="board.paperTitle"
                    > 
                        <!-- {{board.paperTitle}}  -->
                    </div>
                    <div class="list-btm clear">
                        <!-- <dl class="member-list noicon fl">
                            <dt>
                                <button type="button" class="ico-txt_user">
                                    {{board.regUserName}} <b>{{board.paperUserCount > 999 ? '999+':board.paperUserCount}}</b>
                                </button>
                            </dt>
                            <dd class="layer-cnt_ty1 scroll">
                                <div class="layer-tit">총 {{board.paperUserCount}}명</div>
                                <div class="scroll_inner" style="height: 70px">
                                    <template v-for="(user, idx) in board.paperUserList"  >
                                        {{user.userName}} {{idx == board.paperUserCount ? '':','}}
                                    </template>    
                                </div>
                            </dd>
                        </dl> -->
                        <div class="member-list fl">
                            {{ defaultLanguage.indexOf('ko') != -1 ? board.regUserName : board.regUserNameEn != null ? board.regUserNameEn : board.regUserName }} 
                            <b v-if="board.paperUsercount > 1">{{board.paperUsercount > 999 ? '999+':board.paperUsercount}}</b>
                        </div>
                        <div class="list-date fr">
                            {{ $moment(board.lastUpdDate).format("YYYY.MM.DD") }}
                            <span class="ico-new" v-if="board.readCount == null || board.readCount == 0"></span>
                            <!-- <br /> -->
                            <!-- <momentAgo prefix="최종 수정" suffix="전" :date="board.lastUpdDate" lang="kr"></momentAgo> -->
                        </div>
                    </div>
                    <div class="tooltip-b tl small" style="z-index: 11; display: none; word-break: break-all" :id="board.paperId+'_tooltip'">
                        <!-- tooltip -->
                        {{ board.paperTitle }}
                    </div>
                </swiper-slide>  
                <div class="swiper-button-prev" :class="overArea ? '' :'mouseLeave'" slot="button-prev">prev</div> <!-- v-show="overArea" -->
                <div class="swiper-button-next" :class="overArea ? '' :'mouseLeave'" slot="button-next">next</div>
            </swiper> 
        </div> 
        <div class="division" v-if="!view" style="margin-bottom: 54px;">
            <div class="sub_tit_box clear">
                <h3 class="fl ell-singleline" @click="moveCategoryMore" style="cursor: pointer;max-width: calc(95%); display: block;">{{category.categoryName}}</h3>
                <h3>&nbsp;&nbsp;({{boardListFilter.length}})</h3>
            </div>
            <div class="nodata-txt small" v-if="noneRead == false && filterBookmark==false">
                {{ $i18nUtil.trans("search.016", "최근 업데이트된 보드가 없습니다.") }}
            </div>
            <div class="nodata-txt small" v-if="noneRead || filterBookmark">
                {{ $i18nUtil.trans("search.007", "조회된 결과가 없습니다.") }}
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Navigation error로 아래 내용으로 대체
import {Swiper as SwiperClass, Scrollbar, Navigation} from 'swiper/swiper.esm.js'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// Swiper modules
SwiperClass.use([Scrollbar, Navigation])
// local component
const {directive} = getAwesomeSwiper(SwiperClass)

export default {
  props: ["category","filterBookmark","noneRead","filterData"],
  data() {
    return {
        overArea:false,
        toastInfo: {
            obj: this.$toasted,
            message: "",
            options: {
                theme: "toasted-primary",
                position: "bottom-left",
                duration: 3000,
            },
        },
        selectedYn : true,
        view :false,
        swiperOption: {
            slidesPerView: 4,
            spaceBetween: 20,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        },
        boardList: [],
        boardListFilter:[],
        myUserId:'',  

        changeFilterData : false,

        defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
    };
  },
  mounted() {
    /* 카테고리 별 보드 목록 */
    this.getCfrcPaperList();
  },
  watch:{
      filterBookmark(){  
        this.changeFilterData = true;
      },
      noneRead(){ 
        this.changeFilterData = true;
      },
      filterData(){
        this.changeFilterData = true;
      },
      changeFilterData(){
        if(this.changeFilterData){ 
            this.setCfrcNoneReadCount(-1);
            if(this.filterData.filterCategoryList == null){
                this.getCfrcPaperList();
            }else{
                if(this.filterData.filterCategoryList.indexOf(this.category.categoryMid) != -1
                    && this.filterData.filterGradeList.indexOf(this.category.docGrade) != -1){
                    this.getCfrcPaperList();
                    this.selectedYn = true;
                    this.$emit("viewYn", this.selectedYn);
                }else{
                    this.selectedYn = false;
                    this.$emit("viewYn", this.selectedYn);
                } 
            }
            this.changeFilterData = false; 
        }
      }
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapMutations("shareInfo", ["setCfrcNoneReadCount"]),
    ...mapActions("modals", ["showToast"]),

    /* 말줄임(...) 시, tooltip 적용 */
    mouseEvt(flag, element, event) {
        let tooltipId = element.paperId+'_tooltip';
        if(flag) {
            // 말줄임(...) css 적용 여부 체크 (boolean)
            let val = this.$tooltip.hasOverflownHeightRemoveClass(event.target, "ellipsisdot");

            if(val) {
                document.getElementById(tooltipId).style.display = 'block';
            }else{
                document.getElementById(tooltipId).style.display = 'none';
            };
        }else{
            document.getElementById(tooltipId).style.display = 'none';
        }
    },
    moveBoard(list) { 
        // let state ={
        //    categoryMid : list.categoryInfo.categoryMid,
        //    categoryName : list.categoryInfo.categoryName
        // };
        // history.pushState(state, document.title, location.href);  
        let path = "/general/board/" + list.paperId;
        this.$router.push(path);
    },
    /* 카테고리 별 보드 목록 */
    getCfrcPaperList() {  
        this.view = false;
        this.boardList = [];
        this.boardListFilter = []; 
        let obj = this;
        let reqData = { 
            url : "/api/copaper/cooperation/getBoardListInOneWeek",
            method: "post",
            params: { 
                categoryMid: obj.category.categoryMid,
                limitCount : 20,
                isFilterBookmark : obj.filterBookmark ? 1 : 0,
                isFilterNoneRead : obj.noneRead ? 1 : 0
            },
        }; 
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {      
            obj.boardList = res.result;
            obj.boardListFilter = res.result;

            obj.boardList.forEach(function(board){
                if(board.readCount == null || board.readCount == 0){
                    obj.setCfrcNoneReadCount(1); 
                }
            }) 
            
            if(res.result.length == 0 ){
                obj.view = false; 
            }else{
                obj.view = true;
                //보드 상세 정보 API
                obj.getPaperInfoDetail(); 
                obj.multiElipsis(2);
            }
            
            // obj.$emit("viewYn",obj.view);

        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getPaperInfoDetail(){ 
        let paperIdList =[];
        this.boardList.forEach(function(item){
            paperIdList.push(item.paperId);
        })
        let obj = this;
        let reqData = {};
        reqData.params ={
            paperIdList : paperIdList
        }
        reqData.req = obj.req;
        reqData.url = "/api/copaper/infoshare/getPaperInfoDetail";
        reqData.method = "post";
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => { 
            obj.boardListFilter.forEach(function(board){ 
                res.result.paperInfoList.some(function(item){
                    if(item.paperId === board.paperId){ 
                        board.paperLikeYN = item.paperLike;
                        board.paperLikeCount = item.paperLikeCount;
                        board.paperUsercount = item.paperUsercount;
                        if(item.paperBookmark != null){
                            board.paperBookmarkId = item.paperBookmark.paperBookmarkId;
                        }
                        return true;
                    }
                }) 
            }) 
            obj.boardListFilter.push(); 
        })
        .catch(function(err) {
            console.log(err);
        });
    
    },
    toggleBookmark(item){
        event.target.classList.toggle('active'); 
        let obj = this;
        let reqData = {};
        reqData.params ={
            paperId: item.paperId,
            bookmarkId: item.paperBookmarkId
        }
        reqData.req = obj.req;
        reqData.url = "/api/copaper/bookmark/savePaperBookmark";
        reqData.method = "post";
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => { 
            obj.boardList.forEach(function(board){
                if(board.paperId == item.paperId){
                    board.paperBookmarkId = res.result;
                }
            })  
            if(res.result == null){
                //즐겨찾기 해제
                this.toastInfo.message = this.$i18nUtil.trans("TB042", "즐겨찾기가 해제되었습니다.");
                this.showToast(this.toastInfo); 
            }else{
                //즐겨찾기   
                this.toastInfo.message = this.$i18nUtil.trans("TB041", "즐겨찾기가 설정되었습니다.");
                this.showToast(this.toastInfo); 
            }
        }) 
        .catch(function(err) {
            console.log(err);
        });
    }, 
    // setFilter(data){   
    //     // this.myUserId=data.myUserId;  ㄴ
    //     this.boardListFilter = this.boardList;  
    //     if(this.filterBookmark){
    //         this.boardListFilter = this.boardListFilter.filter(function(board){
    //             return board.paperBookmarkId != null;
    //         })
    //     }  

    //     if(this.noneRead){
    //         this.boardListFilter = this.boardListFilter.filter(function(board){
    //             return board.readCount == null || board.readCount == 0;
    //         });
    //     }   

    //     if(this.boardListFilter.length == 0){
    //         this.view =false;
    //     }else{
    //         this.view =true;
    //     }
    // },
    // setUserFilter(filterUserList){      
    //     let jsonString="[";
    //     for(let k in filterUserList){

    //         let filter = filterUserList[k]; 

    //         let result = this.boardListFilter.filter(function(board){
    //             return board.regUserId == filter || board.modUserId == filter;
    //         }); 

    //         if(result.length != 0){
    //             let jsonResultString = JSON.stringify(result);
    //             jsonString += jsonResultString.substring(1,jsonResultString.length-1) +','; 
    //         }
    //     } 

    //     if(jsonString.length != 1){
    //         jsonString = jsonString.slice(0,-1)+"]";
    //     }else{
    //         jsonString="[]";
    //     }
    //     this.boardListFilter = JSON.parse(jsonString); 
    // },
    // setOptionFilter(filterOptionList){ 
    //     let obj = this;
    //     let jsonString="[";
       
    //     let result=this.boardListFilter;
    //     if(filterOptionList.indexOf("my") != -1 ){   
    //         if(filterOptionList.indexOf("member") != -1 ){  
    //             if(filterOptionList.indexOf("all") != -1){  
    //                 result =  this.boardListFilter;
    //             }
    //             if(filterOptionList.indexOf("all") == -1){ 
    //                 result = result.filter(function(board){
    //                     return board.regUserId == obj.myUserId || board.docGrade == "SECRET";
    //                 });
    //             }
    //         } 
    //         if(filterOptionList.indexOf("member") == -1 ){  
    //             if(filterOptionList.indexOf("all") != -1){ 
    //                 result = result.filter(function(board){
    //                     return board.regUserId == obj.myUserId || board.docGrade == "NORMAL";
    //                 });
    //             }
    //             if(filterOptionList.indexOf("all") == -1){ 
    //                 result = result.filter(function(board){
    //                     return board.regUserId == obj.myUserId;
    //                 });
    //             }
    //         } 
    //     }
        
    //     if(filterOptionList.indexOf("my") == -1 ){   
    //         if(filterOptionList.indexOf("member") != -1 ){  
    //             if(filterOptionList.indexOf("all") != -1){ 
    //                 result = result.filter(function(board){
    //                     return board.docGrade == "SECRET" || board.docGrade == "NORMAL";
    //                 });
    //             }
    //             if(filterOptionList.indexOf("all") == -1){ 
    //                 result = result.filter(function(board){
    //                     return board.docGrade == "SECRET";
    //                 });
    //             }
    //         } 
    //         if(filterOptionList.indexOf("member") == -1 ){  
    //             if(filterOptionList.indexOf("all") != -1){ 
    //                 result = result.filter(function(board){
    //                     return board.docGrade == "NORMAL";
    //                 });
    //             }
    //             if(filterOptionList.indexOf("all") == -1){ 
    //                 result = [];
    //             }
    //         } 
    //     }  

    //     if(result.length != 0){
    //         let jsonResultString = JSON.stringify(result);
    //         jsonString += jsonResultString.substring(1,jsonResultString.length-1) +','; 
    //     }
  
    //     if(jsonString.length != 1){
    //         jsonString = jsonString.slice(0,-1)+"]";
    //     }else{
    //         jsonString="[]";
    //     }
    //     this.boardListFilter = JSON.parse(jsonString);
    // },
    moveCategoryMore(){ 
        this.$emit("moveCategoryMore",this.category);
    },
    multiElipsis(ellipsisLine) {  
        this.$nextTick(function(){
            let selecter = "multi-ellipsis "+this.category.categoryMid;
            var omle = document.getElementsByClassName(selecter);  
            for(let item of omle){    
                if (item.scrollHeight > 55) {
                    item.classList.remove("no-ellipsis");
                } else {
                    item.classList.add("no-ellipsis");
                }
            }  
        })
    }, 
  },
};
</script>

<style lang="css" scoped>
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  line-height: 1.44;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.44em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}

.mouseLeave{
    background: url();
    background-color: #eff2f7;
}

.ellipsisdot {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    box-orient: vertical;
    -webkit-box-orient: vertical;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/base/CooperationBoard.vue